export default "__VITE_ASSET__BHLiRMza__"